<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted } from 'vue';
    import axios from 'axios';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    const props = defineProps({});
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        guid: "",
        nom: "", 
        valeurs: [],
    });
    const errors = reactive({
        nom: "",
        valeurs: "",
    });

    async function open(item?: any) {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        if (item) {
            formData.guid = item.guid;
            formData.nom = item.nom;
            formData.valeurs = item.valeurs;
        } else {
            formData.guid = "";
            formData.nom = "";
            formData.valeurs = [];
        }
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.valeurs = '';
        if (!formData.valeurs || formData.valeurs.length === 0) {
            errors.valeurs ="Au moins une énumération est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                guid: formData.guid,
                nom: formData.nom,
                valeurs: formData.valeurs,
            };

            const httpResponse = await axios.post(`/backoffice/market-attributs/save`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
    function handleChangeTag(newTags: any) {
        formData.valeurs = newTags;
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <div style="flex: 1; display: flex; flex-direction:row; justify-content: space-between;">
                <h4 class="font-semibold">Formulaire Attribut</h4>
            </div>
        </template>
        <div>
            <div class="form-field-floating reactive active my-4">
                <input type="text" class="form-input" v-model="formData.nom" name="nom" id="nom" placeholder="" autocomplete="off">
                <label for="nom">Libellé <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!errors['nom']" class="text-red">{{ errors['nom'] }}</span>

            <div class="my-4">
                <label for="nom">Enumérations <b class="color-danger">*</b></label>
                <vue3-tags-input placeholder="Saisir les énumérations" @on-tags-changed="handleChangeTag" :tags="formData.valeurs" />
            </div>
            <span v-if="!!errors['valeurs']" class="text-red">{{ errors['valeurs'] }}</span>
            <div class="clear-both"></div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onSubmit">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
</template>
